import Tooltip from 'components/tooltip/Tooltip'
import { PropTypes } from 'prop-types'
const AvatarList = ({ images, lastItemContent, handleClickLastItem }) => {
	return (
		<div className='avatar-list mt-3 mt-md-0'>
			{images &&
				images.map((image, index) => (
					<Tooltip key={index} text={`${image.user.firstName} ${image.user.lastName}`} containerClass={'avatar-list-item'}>
						<div className="avatar-list-item-img text-semi-bold">
							{image.user.firstName[0]}{image.user.lastName[0]}
						</div>
					</Tooltip>
				))}
			{lastItemContent && (
				<div onClick={handleClickLastItem} className='avatar-list-item-last'>
					{lastItemContent}
				</div>
			)}
		</div>
	)
}

AvatarList.propTypes = {
	images: PropTypes.array,
	lastItemContent: PropTypes.string,
	handleClickLastItem: PropTypes.func
}

export default AvatarList
